export default "__VITE_ASSET__7942e59e__"